import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Main from './components/main/main';
import Layout from './pages/Layout';
import { Startscreen as Sprint } from './sprint/StartScreen/startscreet';
import { Startscreen as AudioChallenge } from './audiochallenge/startscreen/startscreen';
import { TextBook } from './components/textbook/textBook';
import Statistic from './components/statistics/Statistics/Statistic';
import setTextBookGameRoutes from './utils/setTextBookGameRoutes';
var App = function () {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "/", element: React.createElement(Layout, null) },
            React.createElement(Route, { index: true, element: React.createElement(Main, null) }),
            React.createElement(Route, { path: "1", element: React.createElement(TextBook, null) }),
            React.createElement(Route, { path: "2", element: React.createElement(AudioChallenge, null) }),
            React.createElement(Route, { path: "3", element: React.createElement(Sprint, null) }),
            React.createElement(Route, { path: "4", element: React.createElement(Statistic, null) }),
            setTextBookGameRoutes('audio'),
            setTextBookGameRoutes('sprint'),
            React.createElement(Route, { path: "*", element: React.createElement(Main, null) }))));
};
export default App;
